import { createTracker } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
export const usageTracker = createTracker({
  standalone: true,
  allowUnauthed: true,
  isExternalHost: true,
  properties: {
    email: null,
    hubId: null,
    lang: null,
    deviceId: makeUuid()
  }
});